import { localClockOf } from '@kronos/domain'
import type { ComeInRequestView } from '../../data/schedule'
import { STATE_LABEL, shortWindow } from './shared'

/**
 * The requests in one cell, as small squared marks in the request's state:
 * `Asked 9–15`, `In 9–15`, a struck-through declined one. Compact enough that
 * two fit under the availability in a 70px column.
 */
export function CellRequests({ requests, timeZone }: { requests: readonly ComeInRequestView[]; timeZone: string }): JSX.Element | null {
  if (requests.length === 0) return null
  return (
    <span className="sched-reqs">
      {requests.map((r) => {
        const hours = shortWindow({ from: localClockOf(r.startsAt, timeZone), to: localClockOf(r.endsAt, timeZone) })
        return (
          <span
            key={r.id}
            className={`sched-req sched-req--${r.state}`}
            title={`${STATE_LABEL[r.state]} ${hours}${r.note ? ` — ${r.note}` : ''}${r.reply ? ` (“${r.reply}”)` : ''}`}
          >
            {hours}
          </span>
        )
      })}
    </span>
  )
}
